import { render, staticRenderFns } from "./payfail.vue?vue&type=template&id=34fad9d7&scoped=true&"
import script from "./payfail.vue?vue&type=script&lang=js&"
export * from "./payfail.vue?vue&type=script&lang=js&"
import style0 from "./payfail.vue?vue&type=style&index=0&id=34fad9d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fad9d7",
  null
  
)

export default component.exports